import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';

@Injectable()
export class DesenvolvedoresService {

    private URL_API = environment.urlApi + '/api';
    private TOKEN_KEY = 'bth_store_access_token';

    constructor(private httpClient: HttpClient) {
    }

    getAll(): Promise<any> {
        return this.httpClient.get<any>(`${this.URL_API}/desenvolvedores`, this.getHeaders()).toPromise();
    }

    private getHeaders(): any {
        const token: string = localStorage.getItem(this.TOKEN_KEY);
        if (!token && !token.length) {
            return;
        }

        return {headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'}};
    }

}
